import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "@env/environment";
import { CountryModel } from "@models/country.model";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CountryService {
  constructor(private http: HttpClient) {}

  public getCountries$(): Observable<CountryModel[]> {
    return this.http
      .get<CountryModel[]>(`${environment.BASE_URL}country/`)
      .pipe(
        map((data): CountryModel[] => {
          return data;
        })
      );
  }
}
